"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Project/App Name APIs — v1
 * API v1 documentation for the backend services of Project/App Name
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfSetActivePlatformDto = instanceOfSetActivePlatformDto;
exports.SetActivePlatformDtoFromJSON = SetActivePlatformDtoFromJSON;
exports.SetActivePlatformDtoFromJSONTyped = SetActivePlatformDtoFromJSONTyped;
exports.SetActivePlatformDtoToJSON = SetActivePlatformDtoToJSON;
exports.SetActivePlatformDtoToJSONTyped = SetActivePlatformDtoToJSONTyped;
/**
 * Check if a given object implements the SetActivePlatformDto interface.
 */
function instanceOfSetActivePlatformDto(value) {
    if (!('streamingPlatformId' in value) || value['streamingPlatformId'] === undefined)
        return false;
    return true;
}
function SetActivePlatformDtoFromJSON(json) {
    return SetActivePlatformDtoFromJSONTyped(json, false);
}
function SetActivePlatformDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'streamingPlatformId': json['streamingPlatformId'],
    };
}
function SetActivePlatformDtoToJSON(json) {
    return SetActivePlatformDtoToJSONTyped(json, false);
}
function SetActivePlatformDtoToJSONTyped(value, ignoreDiscriminator) {
    if (ignoreDiscriminator === void 0) { ignoreDiscriminator = false; }
    if (value == null) {
        return value;
    }
    return {
        'streamingPlatformId': value['streamingPlatformId'],
    };
}
